module.exports = __webpack_public_path__ + "static/media/step5.d03b7b2c.gif";